import { call } from '@rental/contracts/client'
import type { QueryClient } from '@tanstack/react-query'
import { api, load } from '../api'
import type { Person } from './people'

/**
 * S9: Persone's reads. Under one key, so whatever changes a person reads
 * the list and the page again. A password or a key shown once never comes
 * near this cache: it lives in the answer that made it, in the screen's own
 * state, and goes with it.
 */
export const PEOPLE_KEY = ['people'] as const
export const personKey = (userId: string) => ['people', userId] as const

export const loadPeople = () => load(call(api.GET('/v1/staff/people')))

export const loadPerson = (userId: string) =>
  load(call(api.GET('/v1/staff/people/{userId}', { params: { path: { userId } } })))

/**
 * A person as an answer left them (no secret is in a person): on the page at
 * once, with its new version for the next change, then the list and the
 * page's devices read again.
 */
export function personChanged(queryClient: QueryClient, person: Person) {
  queryClient.setQueryData(
    personKey(person.id),
    (old: Awaited<ReturnType<typeof loadPerson>> | undefined) => (old ? { ...old, person } : old),
  )
  void queryClient.invalidateQueries({ queryKey: PEOPLE_KEY })
}
